import { default as indexmL9Dmi3LaCMeta } from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/create/index.vue?macro=true";
import { default as index9LMl0AUqaDMeta } from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/index.vue?macro=true";
import { default as _91id_93IPnjVQcfKCMeta } from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/update/[id].vue?macro=true";
import { default as dashboardHP9g7FzhRrMeta } from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/dashboard.vue?macro=true";
import { default as logoutzrSAmgLcDSMeta } from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/logout.vue?macro=true";
import { default as mydata4DebCB72l8Meta } from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/mydata.vue?macro=true";
import { default as _91id_9388QWEojtTEMeta } from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/order/[id].vue?macro=true";
import { default as ordersIlftwmRBJnMeta } from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/orders.vue?macro=true";
import { default as wishlistealyqWE5G3Meta } from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/wishlist.vue?macro=true";
import { default as account6LVJzlmehzMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/account.vue?macro=true";
import { default as createpasswordzqfrPQeQ1aMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/auth/createpassword.vue?macro=true";
import { default as loginAdrN53SlCxMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/auth/login.vue?macro=true";
import { default as registerBV17JHQaqzMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/auth/register.vue?macro=true";
import { default as resetpasswordFRXVhaTpEEMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/auth/resetpassword.vue?macro=true";
import { default as _91_46_46_46slug_93B9IZuMJfntMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/c/[...slug].vue?macro=true";
import { default as cartRklFh0BTP9Meta } from "/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-cart-layer/pages/checkout/cart.vue?macro=true";
import { default as createue4XRNDytwMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/create.vue?macro=true";
import { default as indexeKAFtxGyd5Meta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/index.vue?macro=true";
import { default as _91id_93vOPsqYfxToMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/update/[id].vue?macro=true";
import { default as addressesYdAxjCZWHeMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses.vue?macro=true";
import { default as change_45passwordttzeLaD9TLMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/change-password.vue?macro=true";
import { default as editZPNHt6OBxhMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/edit.vue?macro=true";
import { default as index4ZvRccLEjcMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/index.vue?macro=true";
import { default as my_45dataaTguQrtcRaMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data.vue?macro=true";
import { default as newsletterXoiYiY1RtuMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/newsletter.vue?macro=true";
import { default as _91orderNumber_93h77on3VwKuMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/[orderNumber].vue?macro=true";
import { default as _91orderNumber_93WRyKRaJRHFMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/incident/[orderNumber].vue?macro=true";
import { default as indexx1AeJkpMFtMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/index.vue?macro=true";
import { default as _91orderNumber_93q8OCAXPX7oMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/rate/[orderNumber].vue?macro=true";
import { default as ordersBKz5sOuGmdMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/orders.vue?macro=true";
import { default as wishlisteav88h2NmxMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer/wishlist.vue?macro=true";
import { default as customerwrZT4s7QMEMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/customer.vue?macro=true";
import { default as indexodtvIbq6gWMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/index.vue?macro=true";
import { default as loginvTmctQqsFBMeta } from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/login.vue?macro=true";
import { default as indexw6sBeUNupVMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/newsletter-wypis/index.vue?macro=true";
import { default as newsletter_45wypisS1I7Yq3croMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/newsletter-wypis.vue?macro=true";
import { default as confirmZYYZt641yfMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/newsletter/confirm.vue?macro=true";
import { default as indexfqhv1H4qJSMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/newsletter/index.vue?macro=true";
import { default as remove5JYBSBVJ81Meta } from "/home/homeyou/shc/build/build-headless/101573/pages/newsletter/remove.vue?macro=true";
import { default as newsletterQt8Ut9vhktMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/newsletter.vue?macro=true";
import { default as _91_46_46_46slug_93G8QBJF6FuvMeta } from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-product-page-layer/pages/p/[...slug].vue?macro=true";
import { default as _91id_93j5ViPVwKblMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/p/[id].vue?macro=true";
import { default as registerxurUmqSuADMeta } from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/register.vue?macro=true";
import { default as srPzQGllGYDMeta } from "/home/homeyou/shc/build/build-headless/101573/pages/s.vue?macro=true";
import { default as storeLocatorL6LmSux5yWMeta } from "/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-store-locator-layer/pages/storeLocator.vue?macro=true";
export default [
  {
    name: account6LVJzlmehzMeta?.name ?? "account",
    path: account6LVJzlmehzMeta?.path ?? "/account",
    children: [
  {
    name: indexmL9Dmi3LaCMeta?.name ?? "account-addresses-create",
    path: indexmL9Dmi3LaCMeta?.path ?? "addresses/create",
    meta: indexmL9Dmi3LaCMeta || {},
    alias: indexmL9Dmi3LaCMeta?.alias || [],
    redirect: indexmL9Dmi3LaCMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/create/index.vue").then(m => m.default || m)
  },
  {
    name: index9LMl0AUqaDMeta?.name ?? "account-addresses",
    path: index9LMl0AUqaDMeta?.path ?? "addresses",
    meta: index9LMl0AUqaDMeta || {},
    alias: index9LMl0AUqaDMeta?.alias || [],
    redirect: index9LMl0AUqaDMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93IPnjVQcfKCMeta?.name ?? "account-addresses-update-id",
    path: _91id_93IPnjVQcfKCMeta?.path ?? "addresses/update/:id()",
    meta: _91id_93IPnjVQcfKCMeta || {},
    alias: _91id_93IPnjVQcfKCMeta?.alias || [],
    redirect: _91id_93IPnjVQcfKCMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/update/[id].vue").then(m => m.default || m)
  },
  {
    name: dashboardHP9g7FzhRrMeta?.name ?? "account-dashboard",
    path: dashboardHP9g7FzhRrMeta?.path ?? "dashboard",
    meta: dashboardHP9g7FzhRrMeta || {},
    alias: dashboardHP9g7FzhRrMeta?.alias || [],
    redirect: dashboardHP9g7FzhRrMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/dashboard.vue").then(m => m.default || m)
  },
  {
    name: logoutzrSAmgLcDSMeta?.name ?? "account-logout",
    path: logoutzrSAmgLcDSMeta?.path ?? "logout",
    meta: logoutzrSAmgLcDSMeta || {},
    alias: logoutzrSAmgLcDSMeta?.alias || [],
    redirect: logoutzrSAmgLcDSMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/logout.vue").then(m => m.default || m)
  },
  {
    name: mydata4DebCB72l8Meta?.name ?? "account-mydata",
    path: mydata4DebCB72l8Meta?.path ?? "mydata",
    meta: mydata4DebCB72l8Meta || {},
    alias: mydata4DebCB72l8Meta?.alias || [],
    redirect: mydata4DebCB72l8Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/mydata.vue").then(m => m.default || m)
  },
  {
    name: _91id_9388QWEojtTEMeta?.name ?? "account-order-id",
    path: _91id_9388QWEojtTEMeta?.path ?? "order/:id()",
    meta: _91id_9388QWEojtTEMeta || {},
    alias: _91id_9388QWEojtTEMeta?.alias || [],
    redirect: _91id_9388QWEojtTEMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/order/[id].vue").then(m => m.default || m)
  },
  {
    name: ordersIlftwmRBJnMeta?.name ?? "account-orders",
    path: ordersIlftwmRBJnMeta?.path ?? "orders",
    meta: ordersIlftwmRBJnMeta || {},
    alias: ordersIlftwmRBJnMeta?.alias || [],
    redirect: ordersIlftwmRBJnMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlistealyqWE5G3Meta?.name ?? "account-wishlist",
    path: wishlistealyqWE5G3Meta?.path ?? "wishlist",
    meta: wishlistealyqWE5G3Meta || {},
    alias: wishlistealyqWE5G3Meta?.alias || [],
    redirect: wishlistealyqWE5G3Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/wishlist.vue").then(m => m.default || m)
  }
],
    meta: account6LVJzlmehzMeta || {},
    alias: account6LVJzlmehzMeta?.alias || [],
    redirect: account6LVJzlmehzMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/account.vue").then(m => m.default || m)
  },
  {
    name: account6LVJzlmehzMeta?.name ?? "account___pl",
    path: account6LVJzlmehzMeta?.path ?? "/pl/account",
    children: [
  {
    name: indexmL9Dmi3LaCMeta?.name ?? "account-addresses-create___pl",
    path: indexmL9Dmi3LaCMeta?.path ?? "addresses/create",
    meta: indexmL9Dmi3LaCMeta || {},
    alias: indexmL9Dmi3LaCMeta?.alias || [],
    redirect: indexmL9Dmi3LaCMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/create/index.vue").then(m => m.default || m)
  },
  {
    name: index9LMl0AUqaDMeta?.name ?? "account-addresses___pl",
    path: index9LMl0AUqaDMeta?.path ?? "addresses",
    meta: index9LMl0AUqaDMeta || {},
    alias: index9LMl0AUqaDMeta?.alias || [],
    redirect: index9LMl0AUqaDMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93IPnjVQcfKCMeta?.name ?? "account-addresses-update-id___pl",
    path: _91id_93IPnjVQcfKCMeta?.path ?? "addresses/update/:id()",
    meta: _91id_93IPnjVQcfKCMeta || {},
    alias: _91id_93IPnjVQcfKCMeta?.alias || [],
    redirect: _91id_93IPnjVQcfKCMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/update/[id].vue").then(m => m.default || m)
  },
  {
    name: dashboardHP9g7FzhRrMeta?.name ?? "account-dashboard___pl",
    path: dashboardHP9g7FzhRrMeta?.path ?? "dashboard",
    meta: dashboardHP9g7FzhRrMeta || {},
    alias: dashboardHP9g7FzhRrMeta?.alias || [],
    redirect: dashboardHP9g7FzhRrMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/dashboard.vue").then(m => m.default || m)
  },
  {
    name: logoutzrSAmgLcDSMeta?.name ?? "account-logout___pl",
    path: logoutzrSAmgLcDSMeta?.path ?? "logout",
    meta: logoutzrSAmgLcDSMeta || {},
    alias: logoutzrSAmgLcDSMeta?.alias || [],
    redirect: logoutzrSAmgLcDSMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/logout.vue").then(m => m.default || m)
  },
  {
    name: mydata4DebCB72l8Meta?.name ?? "account-mydata___pl",
    path: mydata4DebCB72l8Meta?.path ?? "mydata",
    meta: mydata4DebCB72l8Meta || {},
    alias: mydata4DebCB72l8Meta?.alias || [],
    redirect: mydata4DebCB72l8Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/mydata.vue").then(m => m.default || m)
  },
  {
    name: _91id_9388QWEojtTEMeta?.name ?? "account-order-id___pl",
    path: _91id_9388QWEojtTEMeta?.path ?? "order/:id()",
    meta: _91id_9388QWEojtTEMeta || {},
    alias: _91id_9388QWEojtTEMeta?.alias || [],
    redirect: _91id_9388QWEojtTEMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/order/[id].vue").then(m => m.default || m)
  },
  {
    name: ordersIlftwmRBJnMeta?.name ?? "account-orders___pl",
    path: ordersIlftwmRBJnMeta?.path ?? "orders",
    meta: ordersIlftwmRBJnMeta || {},
    alias: ordersIlftwmRBJnMeta?.alias || [],
    redirect: ordersIlftwmRBJnMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlistealyqWE5G3Meta?.name ?? "account-wishlist___pl",
    path: wishlistealyqWE5G3Meta?.path ?? "wishlist",
    meta: wishlistealyqWE5G3Meta || {},
    alias: wishlistealyqWE5G3Meta?.alias || [],
    redirect: wishlistealyqWE5G3Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/wishlist.vue").then(m => m.default || m)
  }
],
    meta: account6LVJzlmehzMeta || {},
    alias: account6LVJzlmehzMeta?.alias || [],
    redirect: account6LVJzlmehzMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/account.vue").then(m => m.default || m)
  },
  {
    name: account6LVJzlmehzMeta?.name ?? "account___en",
    path: account6LVJzlmehzMeta?.path ?? "/en/account",
    children: [
  {
    name: indexmL9Dmi3LaCMeta?.name ?? "account-addresses-create___en",
    path: indexmL9Dmi3LaCMeta?.path ?? "addresses/create",
    meta: indexmL9Dmi3LaCMeta || {},
    alias: indexmL9Dmi3LaCMeta?.alias || [],
    redirect: indexmL9Dmi3LaCMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/create/index.vue").then(m => m.default || m)
  },
  {
    name: index9LMl0AUqaDMeta?.name ?? "account-addresses___en",
    path: index9LMl0AUqaDMeta?.path ?? "addresses",
    meta: index9LMl0AUqaDMeta || {},
    alias: index9LMl0AUqaDMeta?.alias || [],
    redirect: index9LMl0AUqaDMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93IPnjVQcfKCMeta?.name ?? "account-addresses-update-id___en",
    path: _91id_93IPnjVQcfKCMeta?.path ?? "addresses/update/:id()",
    meta: _91id_93IPnjVQcfKCMeta || {},
    alias: _91id_93IPnjVQcfKCMeta?.alias || [],
    redirect: _91id_93IPnjVQcfKCMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/update/[id].vue").then(m => m.default || m)
  },
  {
    name: dashboardHP9g7FzhRrMeta?.name ?? "account-dashboard___en",
    path: dashboardHP9g7FzhRrMeta?.path ?? "dashboard",
    meta: dashboardHP9g7FzhRrMeta || {},
    alias: dashboardHP9g7FzhRrMeta?.alias || [],
    redirect: dashboardHP9g7FzhRrMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/dashboard.vue").then(m => m.default || m)
  },
  {
    name: logoutzrSAmgLcDSMeta?.name ?? "account-logout___en",
    path: logoutzrSAmgLcDSMeta?.path ?? "logout",
    meta: logoutzrSAmgLcDSMeta || {},
    alias: logoutzrSAmgLcDSMeta?.alias || [],
    redirect: logoutzrSAmgLcDSMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/logout.vue").then(m => m.default || m)
  },
  {
    name: mydata4DebCB72l8Meta?.name ?? "account-mydata___en",
    path: mydata4DebCB72l8Meta?.path ?? "mydata",
    meta: mydata4DebCB72l8Meta || {},
    alias: mydata4DebCB72l8Meta?.alias || [],
    redirect: mydata4DebCB72l8Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/mydata.vue").then(m => m.default || m)
  },
  {
    name: _91id_9388QWEojtTEMeta?.name ?? "account-order-id___en",
    path: _91id_9388QWEojtTEMeta?.path ?? "order/:id()",
    meta: _91id_9388QWEojtTEMeta || {},
    alias: _91id_9388QWEojtTEMeta?.alias || [],
    redirect: _91id_9388QWEojtTEMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/order/[id].vue").then(m => m.default || m)
  },
  {
    name: ordersIlftwmRBJnMeta?.name ?? "account-orders___en",
    path: ordersIlftwmRBJnMeta?.path ?? "orders",
    meta: ordersIlftwmRBJnMeta || {},
    alias: ordersIlftwmRBJnMeta?.alias || [],
    redirect: ordersIlftwmRBJnMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlistealyqWE5G3Meta?.name ?? "account-wishlist___en",
    path: wishlistealyqWE5G3Meta?.path ?? "wishlist",
    meta: wishlistealyqWE5G3Meta || {},
    alias: wishlistealyqWE5G3Meta?.alias || [],
    redirect: wishlistealyqWE5G3Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/wishlist.vue").then(m => m.default || m)
  }
],
    meta: account6LVJzlmehzMeta || {},
    alias: account6LVJzlmehzMeta?.alias || [],
    redirect: account6LVJzlmehzMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/account.vue").then(m => m.default || m)
  },
  {
    name: account6LVJzlmehzMeta?.name ?? "account___ru",
    path: account6LVJzlmehzMeta?.path ?? "/ru/account",
    children: [
  {
    name: indexmL9Dmi3LaCMeta?.name ?? "account-addresses-create___ru",
    path: indexmL9Dmi3LaCMeta?.path ?? "addresses/create",
    meta: indexmL9Dmi3LaCMeta || {},
    alias: indexmL9Dmi3LaCMeta?.alias || [],
    redirect: indexmL9Dmi3LaCMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/create/index.vue").then(m => m.default || m)
  },
  {
    name: index9LMl0AUqaDMeta?.name ?? "account-addresses___ru",
    path: index9LMl0AUqaDMeta?.path ?? "addresses",
    meta: index9LMl0AUqaDMeta || {},
    alias: index9LMl0AUqaDMeta?.alias || [],
    redirect: index9LMl0AUqaDMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93IPnjVQcfKCMeta?.name ?? "account-addresses-update-id___ru",
    path: _91id_93IPnjVQcfKCMeta?.path ?? "addresses/update/:id()",
    meta: _91id_93IPnjVQcfKCMeta || {},
    alias: _91id_93IPnjVQcfKCMeta?.alias || [],
    redirect: _91id_93IPnjVQcfKCMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/update/[id].vue").then(m => m.default || m)
  },
  {
    name: dashboardHP9g7FzhRrMeta?.name ?? "account-dashboard___ru",
    path: dashboardHP9g7FzhRrMeta?.path ?? "dashboard",
    meta: dashboardHP9g7FzhRrMeta || {},
    alias: dashboardHP9g7FzhRrMeta?.alias || [],
    redirect: dashboardHP9g7FzhRrMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/dashboard.vue").then(m => m.default || m)
  },
  {
    name: logoutzrSAmgLcDSMeta?.name ?? "account-logout___ru",
    path: logoutzrSAmgLcDSMeta?.path ?? "logout",
    meta: logoutzrSAmgLcDSMeta || {},
    alias: logoutzrSAmgLcDSMeta?.alias || [],
    redirect: logoutzrSAmgLcDSMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/logout.vue").then(m => m.default || m)
  },
  {
    name: mydata4DebCB72l8Meta?.name ?? "account-mydata___ru",
    path: mydata4DebCB72l8Meta?.path ?? "mydata",
    meta: mydata4DebCB72l8Meta || {},
    alias: mydata4DebCB72l8Meta?.alias || [],
    redirect: mydata4DebCB72l8Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/mydata.vue").then(m => m.default || m)
  },
  {
    name: _91id_9388QWEojtTEMeta?.name ?? "account-order-id___ru",
    path: _91id_9388QWEojtTEMeta?.path ?? "order/:id()",
    meta: _91id_9388QWEojtTEMeta || {},
    alias: _91id_9388QWEojtTEMeta?.alias || [],
    redirect: _91id_9388QWEojtTEMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/order/[id].vue").then(m => m.default || m)
  },
  {
    name: ordersIlftwmRBJnMeta?.name ?? "account-orders___ru",
    path: ordersIlftwmRBJnMeta?.path ?? "orders",
    meta: ordersIlftwmRBJnMeta || {},
    alias: ordersIlftwmRBJnMeta?.alias || [],
    redirect: ordersIlftwmRBJnMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlistealyqWE5G3Meta?.name ?? "account-wishlist___ru",
    path: wishlistealyqWE5G3Meta?.path ?? "wishlist",
    meta: wishlistealyqWE5G3Meta || {},
    alias: wishlistealyqWE5G3Meta?.alias || [],
    redirect: wishlistealyqWE5G3Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/account/wishlist.vue").then(m => m.default || m)
  }
],
    meta: account6LVJzlmehzMeta || {},
    alias: account6LVJzlmehzMeta?.alias || [],
    redirect: account6LVJzlmehzMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/account.vue").then(m => m.default || m)
  },
  {
    name: createpasswordzqfrPQeQ1aMeta?.name ?? "auth-createpassword",
    path: createpasswordzqfrPQeQ1aMeta?.path ?? "/auth/createpassword",
    meta: createpasswordzqfrPQeQ1aMeta || {},
    alias: createpasswordzqfrPQeQ1aMeta?.alias || [],
    redirect: createpasswordzqfrPQeQ1aMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/createpassword.vue").then(m => m.default || m)
  },
  {
    name: createpasswordzqfrPQeQ1aMeta?.name ?? "auth-createpassword___pl",
    path: createpasswordzqfrPQeQ1aMeta?.path ?? "/pl/auth/createpassword",
    meta: createpasswordzqfrPQeQ1aMeta || {},
    alias: createpasswordzqfrPQeQ1aMeta?.alias || [],
    redirect: createpasswordzqfrPQeQ1aMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/createpassword.vue").then(m => m.default || m)
  },
  {
    name: createpasswordzqfrPQeQ1aMeta?.name ?? "auth-createpassword___en",
    path: createpasswordzqfrPQeQ1aMeta?.path ?? "/en/auth/createpassword",
    meta: createpasswordzqfrPQeQ1aMeta || {},
    alias: createpasswordzqfrPQeQ1aMeta?.alias || [],
    redirect: createpasswordzqfrPQeQ1aMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/createpassword.vue").then(m => m.default || m)
  },
  {
    name: createpasswordzqfrPQeQ1aMeta?.name ?? "auth-createpassword___ru",
    path: createpasswordzqfrPQeQ1aMeta?.path ?? "/ru/auth/createpassword",
    meta: createpasswordzqfrPQeQ1aMeta || {},
    alias: createpasswordzqfrPQeQ1aMeta?.alias || [],
    redirect: createpasswordzqfrPQeQ1aMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/createpassword.vue").then(m => m.default || m)
  },
  {
    name: loginAdrN53SlCxMeta?.name ?? "auth-login",
    path: loginAdrN53SlCxMeta?.path ?? "/auth/login",
    meta: loginAdrN53SlCxMeta || {},
    alias: loginAdrN53SlCxMeta?.alias || [],
    redirect: loginAdrN53SlCxMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: loginAdrN53SlCxMeta?.name ?? "auth-login___pl",
    path: loginAdrN53SlCxMeta?.path ?? "/pl/auth/login",
    meta: loginAdrN53SlCxMeta || {},
    alias: loginAdrN53SlCxMeta?.alias || [],
    redirect: loginAdrN53SlCxMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: loginAdrN53SlCxMeta?.name ?? "auth-login___en",
    path: loginAdrN53SlCxMeta?.path ?? "/en/auth/login",
    meta: loginAdrN53SlCxMeta || {},
    alias: loginAdrN53SlCxMeta?.alias || [],
    redirect: loginAdrN53SlCxMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: loginAdrN53SlCxMeta?.name ?? "auth-login___ru",
    path: loginAdrN53SlCxMeta?.path ?? "/ru/auth/login",
    meta: loginAdrN53SlCxMeta || {},
    alias: loginAdrN53SlCxMeta?.alias || [],
    redirect: loginAdrN53SlCxMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: registerBV17JHQaqzMeta?.name ?? "auth-register",
    path: registerBV17JHQaqzMeta?.path ?? "/auth/register",
    meta: registerBV17JHQaqzMeta || {},
    alias: registerBV17JHQaqzMeta?.alias || [],
    redirect: registerBV17JHQaqzMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/register.vue").then(m => m.default || m)
  },
  {
    name: registerBV17JHQaqzMeta?.name ?? "auth-register___pl",
    path: registerBV17JHQaqzMeta?.path ?? "/pl/auth/register",
    meta: registerBV17JHQaqzMeta || {},
    alias: registerBV17JHQaqzMeta?.alias || [],
    redirect: registerBV17JHQaqzMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/register.vue").then(m => m.default || m)
  },
  {
    name: registerBV17JHQaqzMeta?.name ?? "auth-register___en",
    path: registerBV17JHQaqzMeta?.path ?? "/en/auth/register",
    meta: registerBV17JHQaqzMeta || {},
    alias: registerBV17JHQaqzMeta?.alias || [],
    redirect: registerBV17JHQaqzMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/register.vue").then(m => m.default || m)
  },
  {
    name: registerBV17JHQaqzMeta?.name ?? "auth-register___ru",
    path: registerBV17JHQaqzMeta?.path ?? "/ru/auth/register",
    meta: registerBV17JHQaqzMeta || {},
    alias: registerBV17JHQaqzMeta?.alias || [],
    redirect: registerBV17JHQaqzMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/register.vue").then(m => m.default || m)
  },
  {
    name: resetpasswordFRXVhaTpEEMeta?.name ?? "auth-resetpassword",
    path: resetpasswordFRXVhaTpEEMeta?.path ?? "/auth/resetpassword",
    meta: resetpasswordFRXVhaTpEEMeta || {},
    alias: resetpasswordFRXVhaTpEEMeta?.alias || [],
    redirect: resetpasswordFRXVhaTpEEMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/resetpassword.vue").then(m => m.default || m)
  },
  {
    name: resetpasswordFRXVhaTpEEMeta?.name ?? "auth-resetpassword___pl",
    path: resetpasswordFRXVhaTpEEMeta?.path ?? "/pl/auth/resetpassword",
    meta: resetpasswordFRXVhaTpEEMeta || {},
    alias: resetpasswordFRXVhaTpEEMeta?.alias || [],
    redirect: resetpasswordFRXVhaTpEEMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/resetpassword.vue").then(m => m.default || m)
  },
  {
    name: resetpasswordFRXVhaTpEEMeta?.name ?? "auth-resetpassword___en",
    path: resetpasswordFRXVhaTpEEMeta?.path ?? "/en/auth/resetpassword",
    meta: resetpasswordFRXVhaTpEEMeta || {},
    alias: resetpasswordFRXVhaTpEEMeta?.alias || [],
    redirect: resetpasswordFRXVhaTpEEMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/resetpassword.vue").then(m => m.default || m)
  },
  {
    name: resetpasswordFRXVhaTpEEMeta?.name ?? "auth-resetpassword___ru",
    path: resetpasswordFRXVhaTpEEMeta?.path ?? "/ru/auth/resetpassword",
    meta: resetpasswordFRXVhaTpEEMeta || {},
    alias: resetpasswordFRXVhaTpEEMeta?.alias || [],
    redirect: resetpasswordFRXVhaTpEEMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/auth/resetpassword.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93B9IZuMJfntMeta?.name ?? "c-slug",
    path: _91_46_46_46slug_93B9IZuMJfntMeta?.path ?? "/c/:slug(.*)*",
    meta: _91_46_46_46slug_93B9IZuMJfntMeta || {},
    alias: _91_46_46_46slug_93B9IZuMJfntMeta?.alias || [],
    redirect: _91_46_46_46slug_93B9IZuMJfntMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93B9IZuMJfntMeta?.name ?? "c-slug___pl",
    path: _91_46_46_46slug_93B9IZuMJfntMeta?.path ?? "/pl/c/:slug(.*)*",
    meta: _91_46_46_46slug_93B9IZuMJfntMeta || {},
    alias: _91_46_46_46slug_93B9IZuMJfntMeta?.alias || [],
    redirect: _91_46_46_46slug_93B9IZuMJfntMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93B9IZuMJfntMeta?.name ?? "c-slug___en",
    path: _91_46_46_46slug_93B9IZuMJfntMeta?.path ?? "/en/c/:slug(.*)*",
    meta: _91_46_46_46slug_93B9IZuMJfntMeta || {},
    alias: _91_46_46_46slug_93B9IZuMJfntMeta?.alias || [],
    redirect: _91_46_46_46slug_93B9IZuMJfntMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93B9IZuMJfntMeta?.name ?? "c-slug___ru",
    path: _91_46_46_46slug_93B9IZuMJfntMeta?.path ?? "/ru/c/:slug(.*)*",
    meta: _91_46_46_46slug_93B9IZuMJfntMeta || {},
    alias: _91_46_46_46slug_93B9IZuMJfntMeta?.alias || [],
    redirect: _91_46_46_46slug_93B9IZuMJfntMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: cartRklFh0BTP9Meta?.name ?? "checkout-cart",
    path: cartRklFh0BTP9Meta?.path ?? "/checkout/cart",
    meta: cartRklFh0BTP9Meta || {},
    alias: cartRklFh0BTP9Meta?.alias || [],
    redirect: cartRklFh0BTP9Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-cart-layer/pages/checkout/cart.vue").then(m => m.default || m)
  },
  {
    name: cartRklFh0BTP9Meta?.name ?? "checkout-cart___pl",
    path: cartRklFh0BTP9Meta?.path ?? "/pl/checkout/cart",
    meta: cartRklFh0BTP9Meta || {},
    alias: cartRklFh0BTP9Meta?.alias || [],
    redirect: cartRklFh0BTP9Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-cart-layer/pages/checkout/cart.vue").then(m => m.default || m)
  },
  {
    name: cartRklFh0BTP9Meta?.name ?? "checkout-cart___en",
    path: cartRklFh0BTP9Meta?.path ?? "/en/checkout/cart",
    meta: cartRklFh0BTP9Meta || {},
    alias: cartRklFh0BTP9Meta?.alias || [],
    redirect: cartRklFh0BTP9Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-cart-layer/pages/checkout/cart.vue").then(m => m.default || m)
  },
  {
    name: cartRklFh0BTP9Meta?.name ?? "checkout-cart___ru",
    path: cartRklFh0BTP9Meta?.path ?? "/ru/checkout/cart",
    meta: cartRklFh0BTP9Meta || {},
    alias: cartRklFh0BTP9Meta?.alias || [],
    redirect: cartRklFh0BTP9Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-cart-layer/pages/checkout/cart.vue").then(m => m.default || m)
  },
  {
    name: customerwrZT4s7QMEMeta?.name ?? "customer",
    path: customerwrZT4s7QMEMeta?.path ?? "/customer",
    children: [
  {
    path: addressesYdAxjCZWHeMeta?.path ?? "addresses",
    children: [
  {
    name: createue4XRNDytwMeta?.name ?? "customer-addresses-create",
    path: createue4XRNDytwMeta?.path ?? "create",
    meta: createue4XRNDytwMeta || {},
    alias: createue4XRNDytwMeta?.alias || [],
    redirect: createue4XRNDytwMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/create.vue").then(m => m.default || m)
  },
  {
    name: indexeKAFtxGyd5Meta?.name ?? "customer-addresses",
    path: indexeKAFtxGyd5Meta?.path ?? "",
    meta: indexeKAFtxGyd5Meta || {},
    alias: indexeKAFtxGyd5Meta?.alias || [],
    redirect: indexeKAFtxGyd5Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93vOPsqYfxToMeta?.name ?? "customer-addresses-update-id",
    path: _91id_93vOPsqYfxToMeta?.path ?? "update/:id()",
    meta: _91id_93vOPsqYfxToMeta || {},
    alias: _91id_93vOPsqYfxToMeta?.alias || [],
    redirect: _91id_93vOPsqYfxToMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/update/[id].vue").then(m => m.default || m)
  }
],
    name: addressesYdAxjCZWHeMeta?.name ?? undefined,
    meta: addressesYdAxjCZWHeMeta || {},
    alias: addressesYdAxjCZWHeMeta?.alias || [],
    redirect: addressesYdAxjCZWHeMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses.vue").then(m => m.default || m)
  },
  {
    path: my_45dataaTguQrtcRaMeta?.path ?? "my-data",
    children: [
  {
    name: change_45passwordttzeLaD9TLMeta?.name ?? "customer-my-data-change-password",
    path: change_45passwordttzeLaD9TLMeta?.path ?? "change-password",
    meta: change_45passwordttzeLaD9TLMeta || {},
    alias: change_45passwordttzeLaD9TLMeta?.alias || [],
    redirect: change_45passwordttzeLaD9TLMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/change-password.vue").then(m => m.default || m)
  },
  {
    name: editZPNHt6OBxhMeta?.name ?? "customer-my-data-edit",
    path: editZPNHt6OBxhMeta?.path ?? "edit",
    meta: editZPNHt6OBxhMeta || {},
    alias: editZPNHt6OBxhMeta?.alias || [],
    redirect: editZPNHt6OBxhMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/edit.vue").then(m => m.default || m)
  },
  {
    name: index4ZvRccLEjcMeta?.name ?? "customer-my-data",
    path: index4ZvRccLEjcMeta?.path ?? "",
    meta: index4ZvRccLEjcMeta || {},
    alias: index4ZvRccLEjcMeta?.alias || [],
    redirect: index4ZvRccLEjcMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/index.vue").then(m => m.default || m)
  }
],
    name: my_45dataaTguQrtcRaMeta?.name ?? undefined,
    meta: my_45dataaTguQrtcRaMeta || {},
    alias: my_45dataaTguQrtcRaMeta?.alias || [],
    redirect: my_45dataaTguQrtcRaMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data.vue").then(m => m.default || m)
  },
  {
    name: newsletterXoiYiY1RtuMeta?.name ?? "customer-newsletter",
    path: newsletterXoiYiY1RtuMeta?.path ?? "newsletter",
    meta: newsletterXoiYiY1RtuMeta || {},
    alias: newsletterXoiYiY1RtuMeta?.alias || [],
    redirect: newsletterXoiYiY1RtuMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/newsletter.vue").then(m => m.default || m)
  },
  {
    path: ordersBKz5sOuGmdMeta?.path ?? "orders",
    children: [
  {
    name: _91orderNumber_93h77on3VwKuMeta?.name ?? "customer-orders-orderNumber",
    path: _91orderNumber_93h77on3VwKuMeta?.path ?? ":orderNumber()",
    meta: _91orderNumber_93h77on3VwKuMeta || {},
    alias: _91orderNumber_93h77on3VwKuMeta?.alias || [],
    redirect: _91orderNumber_93h77on3VwKuMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93WRyKRaJRHFMeta?.name ?? "customer-orders-incident-orderNumber",
    path: _91orderNumber_93WRyKRaJRHFMeta?.path ?? "incident/:orderNumber()",
    meta: _91orderNumber_93WRyKRaJRHFMeta || {},
    alias: _91orderNumber_93WRyKRaJRHFMeta?.alias || [],
    redirect: _91orderNumber_93WRyKRaJRHFMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/incident/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: indexx1AeJkpMFtMeta?.name ?? "customer-orders",
    path: indexx1AeJkpMFtMeta?.path ?? "",
    meta: indexx1AeJkpMFtMeta || {},
    alias: indexx1AeJkpMFtMeta?.alias || [],
    redirect: indexx1AeJkpMFtMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93q8OCAXPX7oMeta?.name ?? "customer-orders-rate-orderNumber",
    path: _91orderNumber_93q8OCAXPX7oMeta?.path ?? "rate/:orderNumber()",
    meta: _91orderNumber_93q8OCAXPX7oMeta || {},
    alias: _91orderNumber_93q8OCAXPX7oMeta?.alias || [],
    redirect: _91orderNumber_93q8OCAXPX7oMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/rate/[orderNumber].vue").then(m => m.default || m)
  }
],
    name: ordersBKz5sOuGmdMeta?.name ?? undefined,
    meta: ordersBKz5sOuGmdMeta || {},
    alias: ordersBKz5sOuGmdMeta?.alias || [],
    redirect: ordersBKz5sOuGmdMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlisteav88h2NmxMeta?.name ?? "customer-wishlist",
    path: wishlisteav88h2NmxMeta?.path ?? "wishlist",
    meta: wishlisteav88h2NmxMeta || {},
    alias: wishlisteav88h2NmxMeta?.alias || [],
    redirect: wishlisteav88h2NmxMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/wishlist.vue").then(m => m.default || m)
  }
],
    meta: customerwrZT4s7QMEMeta || {},
    alias: customerwrZT4s7QMEMeta?.alias || [],
    redirect: customerwrZT4s7QMEMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer.vue").then(m => m.default || m)
  },
  {
    name: customerwrZT4s7QMEMeta?.name ?? "customer___pl",
    path: customerwrZT4s7QMEMeta?.path ?? "/pl/customer",
    children: [
  {
    path: addressesYdAxjCZWHeMeta?.path ?? "addresses",
    children: [
  {
    name: createue4XRNDytwMeta?.name ?? "customer-addresses-create___pl",
    path: createue4XRNDytwMeta?.path ?? "create",
    meta: createue4XRNDytwMeta || {},
    alias: createue4XRNDytwMeta?.alias || [],
    redirect: createue4XRNDytwMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/create.vue").then(m => m.default || m)
  },
  {
    name: indexeKAFtxGyd5Meta?.name ?? "customer-addresses___pl",
    path: indexeKAFtxGyd5Meta?.path ?? "",
    meta: indexeKAFtxGyd5Meta || {},
    alias: indexeKAFtxGyd5Meta?.alias || [],
    redirect: indexeKAFtxGyd5Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93vOPsqYfxToMeta?.name ?? "customer-addresses-update-id___pl",
    path: _91id_93vOPsqYfxToMeta?.path ?? "update/:id()",
    meta: _91id_93vOPsqYfxToMeta || {},
    alias: _91id_93vOPsqYfxToMeta?.alias || [],
    redirect: _91id_93vOPsqYfxToMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/update/[id].vue").then(m => m.default || m)
  }
],
    name: addressesYdAxjCZWHeMeta?.name ?? undefined,
    meta: addressesYdAxjCZWHeMeta || {},
    alias: addressesYdAxjCZWHeMeta?.alias || [],
    redirect: addressesYdAxjCZWHeMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses.vue").then(m => m.default || m)
  },
  {
    path: my_45dataaTguQrtcRaMeta?.path ?? "my-data",
    children: [
  {
    name: change_45passwordttzeLaD9TLMeta?.name ?? "customer-my-data-change-password___pl",
    path: change_45passwordttzeLaD9TLMeta?.path ?? "change-password",
    meta: change_45passwordttzeLaD9TLMeta || {},
    alias: change_45passwordttzeLaD9TLMeta?.alias || [],
    redirect: change_45passwordttzeLaD9TLMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/change-password.vue").then(m => m.default || m)
  },
  {
    name: editZPNHt6OBxhMeta?.name ?? "customer-my-data-edit___pl",
    path: editZPNHt6OBxhMeta?.path ?? "edit",
    meta: editZPNHt6OBxhMeta || {},
    alias: editZPNHt6OBxhMeta?.alias || [],
    redirect: editZPNHt6OBxhMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/edit.vue").then(m => m.default || m)
  },
  {
    name: index4ZvRccLEjcMeta?.name ?? "customer-my-data___pl",
    path: index4ZvRccLEjcMeta?.path ?? "",
    meta: index4ZvRccLEjcMeta || {},
    alias: index4ZvRccLEjcMeta?.alias || [],
    redirect: index4ZvRccLEjcMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/index.vue").then(m => m.default || m)
  }
],
    name: my_45dataaTguQrtcRaMeta?.name ?? undefined,
    meta: my_45dataaTguQrtcRaMeta || {},
    alias: my_45dataaTguQrtcRaMeta?.alias || [],
    redirect: my_45dataaTguQrtcRaMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data.vue").then(m => m.default || m)
  },
  {
    name: newsletterXoiYiY1RtuMeta?.name ?? "customer-newsletter___pl",
    path: newsletterXoiYiY1RtuMeta?.path ?? "newsletter",
    meta: newsletterXoiYiY1RtuMeta || {},
    alias: newsletterXoiYiY1RtuMeta?.alias || [],
    redirect: newsletterXoiYiY1RtuMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/newsletter.vue").then(m => m.default || m)
  },
  {
    path: ordersBKz5sOuGmdMeta?.path ?? "orders",
    children: [
  {
    name: _91orderNumber_93h77on3VwKuMeta?.name ?? "customer-orders-orderNumber___pl",
    path: _91orderNumber_93h77on3VwKuMeta?.path ?? ":orderNumber()",
    meta: _91orderNumber_93h77on3VwKuMeta || {},
    alias: _91orderNumber_93h77on3VwKuMeta?.alias || [],
    redirect: _91orderNumber_93h77on3VwKuMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93WRyKRaJRHFMeta?.name ?? "customer-orders-incident-orderNumber___pl",
    path: _91orderNumber_93WRyKRaJRHFMeta?.path ?? "incident/:orderNumber()",
    meta: _91orderNumber_93WRyKRaJRHFMeta || {},
    alias: _91orderNumber_93WRyKRaJRHFMeta?.alias || [],
    redirect: _91orderNumber_93WRyKRaJRHFMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/incident/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: indexx1AeJkpMFtMeta?.name ?? "customer-orders___pl",
    path: indexx1AeJkpMFtMeta?.path ?? "",
    meta: indexx1AeJkpMFtMeta || {},
    alias: indexx1AeJkpMFtMeta?.alias || [],
    redirect: indexx1AeJkpMFtMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93q8OCAXPX7oMeta?.name ?? "customer-orders-rate-orderNumber___pl",
    path: _91orderNumber_93q8OCAXPX7oMeta?.path ?? "rate/:orderNumber()",
    meta: _91orderNumber_93q8OCAXPX7oMeta || {},
    alias: _91orderNumber_93q8OCAXPX7oMeta?.alias || [],
    redirect: _91orderNumber_93q8OCAXPX7oMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/rate/[orderNumber].vue").then(m => m.default || m)
  }
],
    name: ordersBKz5sOuGmdMeta?.name ?? undefined,
    meta: ordersBKz5sOuGmdMeta || {},
    alias: ordersBKz5sOuGmdMeta?.alias || [],
    redirect: ordersBKz5sOuGmdMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlisteav88h2NmxMeta?.name ?? "customer-wishlist___pl",
    path: wishlisteav88h2NmxMeta?.path ?? "wishlist",
    meta: wishlisteav88h2NmxMeta || {},
    alias: wishlisteav88h2NmxMeta?.alias || [],
    redirect: wishlisteav88h2NmxMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/wishlist.vue").then(m => m.default || m)
  }
],
    meta: customerwrZT4s7QMEMeta || {},
    alias: customerwrZT4s7QMEMeta?.alias || [],
    redirect: customerwrZT4s7QMEMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer.vue").then(m => m.default || m)
  },
  {
    name: customerwrZT4s7QMEMeta?.name ?? "customer___en",
    path: customerwrZT4s7QMEMeta?.path ?? "/en/customer",
    children: [
  {
    path: addressesYdAxjCZWHeMeta?.path ?? "addresses",
    children: [
  {
    name: createue4XRNDytwMeta?.name ?? "customer-addresses-create___en",
    path: createue4XRNDytwMeta?.path ?? "create",
    meta: createue4XRNDytwMeta || {},
    alias: createue4XRNDytwMeta?.alias || [],
    redirect: createue4XRNDytwMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/create.vue").then(m => m.default || m)
  },
  {
    name: indexeKAFtxGyd5Meta?.name ?? "customer-addresses___en",
    path: indexeKAFtxGyd5Meta?.path ?? "",
    meta: indexeKAFtxGyd5Meta || {},
    alias: indexeKAFtxGyd5Meta?.alias || [],
    redirect: indexeKAFtxGyd5Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93vOPsqYfxToMeta?.name ?? "customer-addresses-update-id___en",
    path: _91id_93vOPsqYfxToMeta?.path ?? "update/:id()",
    meta: _91id_93vOPsqYfxToMeta || {},
    alias: _91id_93vOPsqYfxToMeta?.alias || [],
    redirect: _91id_93vOPsqYfxToMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/update/[id].vue").then(m => m.default || m)
  }
],
    name: addressesYdAxjCZWHeMeta?.name ?? undefined,
    meta: addressesYdAxjCZWHeMeta || {},
    alias: addressesYdAxjCZWHeMeta?.alias || [],
    redirect: addressesYdAxjCZWHeMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses.vue").then(m => m.default || m)
  },
  {
    path: my_45dataaTguQrtcRaMeta?.path ?? "my-data",
    children: [
  {
    name: change_45passwordttzeLaD9TLMeta?.name ?? "customer-my-data-change-password___en",
    path: change_45passwordttzeLaD9TLMeta?.path ?? "change-password",
    meta: change_45passwordttzeLaD9TLMeta || {},
    alias: change_45passwordttzeLaD9TLMeta?.alias || [],
    redirect: change_45passwordttzeLaD9TLMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/change-password.vue").then(m => m.default || m)
  },
  {
    name: editZPNHt6OBxhMeta?.name ?? "customer-my-data-edit___en",
    path: editZPNHt6OBxhMeta?.path ?? "edit",
    meta: editZPNHt6OBxhMeta || {},
    alias: editZPNHt6OBxhMeta?.alias || [],
    redirect: editZPNHt6OBxhMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/edit.vue").then(m => m.default || m)
  },
  {
    name: index4ZvRccLEjcMeta?.name ?? "customer-my-data___en",
    path: index4ZvRccLEjcMeta?.path ?? "",
    meta: index4ZvRccLEjcMeta || {},
    alias: index4ZvRccLEjcMeta?.alias || [],
    redirect: index4ZvRccLEjcMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/index.vue").then(m => m.default || m)
  }
],
    name: my_45dataaTguQrtcRaMeta?.name ?? undefined,
    meta: my_45dataaTguQrtcRaMeta || {},
    alias: my_45dataaTguQrtcRaMeta?.alias || [],
    redirect: my_45dataaTguQrtcRaMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data.vue").then(m => m.default || m)
  },
  {
    name: newsletterXoiYiY1RtuMeta?.name ?? "customer-newsletter___en",
    path: newsletterXoiYiY1RtuMeta?.path ?? "newsletter",
    meta: newsletterXoiYiY1RtuMeta || {},
    alias: newsletterXoiYiY1RtuMeta?.alias || [],
    redirect: newsletterXoiYiY1RtuMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/newsletter.vue").then(m => m.default || m)
  },
  {
    path: ordersBKz5sOuGmdMeta?.path ?? "orders",
    children: [
  {
    name: _91orderNumber_93h77on3VwKuMeta?.name ?? "customer-orders-orderNumber___en",
    path: _91orderNumber_93h77on3VwKuMeta?.path ?? ":orderNumber()",
    meta: _91orderNumber_93h77on3VwKuMeta || {},
    alias: _91orderNumber_93h77on3VwKuMeta?.alias || [],
    redirect: _91orderNumber_93h77on3VwKuMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93WRyKRaJRHFMeta?.name ?? "customer-orders-incident-orderNumber___en",
    path: _91orderNumber_93WRyKRaJRHFMeta?.path ?? "incident/:orderNumber()",
    meta: _91orderNumber_93WRyKRaJRHFMeta || {},
    alias: _91orderNumber_93WRyKRaJRHFMeta?.alias || [],
    redirect: _91orderNumber_93WRyKRaJRHFMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/incident/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: indexx1AeJkpMFtMeta?.name ?? "customer-orders___en",
    path: indexx1AeJkpMFtMeta?.path ?? "",
    meta: indexx1AeJkpMFtMeta || {},
    alias: indexx1AeJkpMFtMeta?.alias || [],
    redirect: indexx1AeJkpMFtMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93q8OCAXPX7oMeta?.name ?? "customer-orders-rate-orderNumber___en",
    path: _91orderNumber_93q8OCAXPX7oMeta?.path ?? "rate/:orderNumber()",
    meta: _91orderNumber_93q8OCAXPX7oMeta || {},
    alias: _91orderNumber_93q8OCAXPX7oMeta?.alias || [],
    redirect: _91orderNumber_93q8OCAXPX7oMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/rate/[orderNumber].vue").then(m => m.default || m)
  }
],
    name: ordersBKz5sOuGmdMeta?.name ?? undefined,
    meta: ordersBKz5sOuGmdMeta || {},
    alias: ordersBKz5sOuGmdMeta?.alias || [],
    redirect: ordersBKz5sOuGmdMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlisteav88h2NmxMeta?.name ?? "customer-wishlist___en",
    path: wishlisteav88h2NmxMeta?.path ?? "wishlist",
    meta: wishlisteav88h2NmxMeta || {},
    alias: wishlisteav88h2NmxMeta?.alias || [],
    redirect: wishlisteav88h2NmxMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/wishlist.vue").then(m => m.default || m)
  }
],
    meta: customerwrZT4s7QMEMeta || {},
    alias: customerwrZT4s7QMEMeta?.alias || [],
    redirect: customerwrZT4s7QMEMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer.vue").then(m => m.default || m)
  },
  {
    name: customerwrZT4s7QMEMeta?.name ?? "customer___ru",
    path: customerwrZT4s7QMEMeta?.path ?? "/ru/customer",
    children: [
  {
    path: addressesYdAxjCZWHeMeta?.path ?? "addresses",
    children: [
  {
    name: createue4XRNDytwMeta?.name ?? "customer-addresses-create___ru",
    path: createue4XRNDytwMeta?.path ?? "create",
    meta: createue4XRNDytwMeta || {},
    alias: createue4XRNDytwMeta?.alias || [],
    redirect: createue4XRNDytwMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/create.vue").then(m => m.default || m)
  },
  {
    name: indexeKAFtxGyd5Meta?.name ?? "customer-addresses___ru",
    path: indexeKAFtxGyd5Meta?.path ?? "",
    meta: indexeKAFtxGyd5Meta || {},
    alias: indexeKAFtxGyd5Meta?.alias || [],
    redirect: indexeKAFtxGyd5Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93vOPsqYfxToMeta?.name ?? "customer-addresses-update-id___ru",
    path: _91id_93vOPsqYfxToMeta?.path ?? "update/:id()",
    meta: _91id_93vOPsqYfxToMeta || {},
    alias: _91id_93vOPsqYfxToMeta?.alias || [],
    redirect: _91id_93vOPsqYfxToMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses/update/[id].vue").then(m => m.default || m)
  }
],
    name: addressesYdAxjCZWHeMeta?.name ?? undefined,
    meta: addressesYdAxjCZWHeMeta || {},
    alias: addressesYdAxjCZWHeMeta?.alias || [],
    redirect: addressesYdAxjCZWHeMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/addresses.vue").then(m => m.default || m)
  },
  {
    path: my_45dataaTguQrtcRaMeta?.path ?? "my-data",
    children: [
  {
    name: change_45passwordttzeLaD9TLMeta?.name ?? "customer-my-data-change-password___ru",
    path: change_45passwordttzeLaD9TLMeta?.path ?? "change-password",
    meta: change_45passwordttzeLaD9TLMeta || {},
    alias: change_45passwordttzeLaD9TLMeta?.alias || [],
    redirect: change_45passwordttzeLaD9TLMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/change-password.vue").then(m => m.default || m)
  },
  {
    name: editZPNHt6OBxhMeta?.name ?? "customer-my-data-edit___ru",
    path: editZPNHt6OBxhMeta?.path ?? "edit",
    meta: editZPNHt6OBxhMeta || {},
    alias: editZPNHt6OBxhMeta?.alias || [],
    redirect: editZPNHt6OBxhMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/edit.vue").then(m => m.default || m)
  },
  {
    name: index4ZvRccLEjcMeta?.name ?? "customer-my-data___ru",
    path: index4ZvRccLEjcMeta?.path ?? "",
    meta: index4ZvRccLEjcMeta || {},
    alias: index4ZvRccLEjcMeta?.alias || [],
    redirect: index4ZvRccLEjcMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data/index.vue").then(m => m.default || m)
  }
],
    name: my_45dataaTguQrtcRaMeta?.name ?? undefined,
    meta: my_45dataaTguQrtcRaMeta || {},
    alias: my_45dataaTguQrtcRaMeta?.alias || [],
    redirect: my_45dataaTguQrtcRaMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/my-data.vue").then(m => m.default || m)
  },
  {
    name: newsletterXoiYiY1RtuMeta?.name ?? "customer-newsletter___ru",
    path: newsletterXoiYiY1RtuMeta?.path ?? "newsletter",
    meta: newsletterXoiYiY1RtuMeta || {},
    alias: newsletterXoiYiY1RtuMeta?.alias || [],
    redirect: newsletterXoiYiY1RtuMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/newsletter.vue").then(m => m.default || m)
  },
  {
    path: ordersBKz5sOuGmdMeta?.path ?? "orders",
    children: [
  {
    name: _91orderNumber_93h77on3VwKuMeta?.name ?? "customer-orders-orderNumber___ru",
    path: _91orderNumber_93h77on3VwKuMeta?.path ?? ":orderNumber()",
    meta: _91orderNumber_93h77on3VwKuMeta || {},
    alias: _91orderNumber_93h77on3VwKuMeta?.alias || [],
    redirect: _91orderNumber_93h77on3VwKuMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93WRyKRaJRHFMeta?.name ?? "customer-orders-incident-orderNumber___ru",
    path: _91orderNumber_93WRyKRaJRHFMeta?.path ?? "incident/:orderNumber()",
    meta: _91orderNumber_93WRyKRaJRHFMeta || {},
    alias: _91orderNumber_93WRyKRaJRHFMeta?.alias || [],
    redirect: _91orderNumber_93WRyKRaJRHFMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/incident/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: indexx1AeJkpMFtMeta?.name ?? "customer-orders___ru",
    path: indexx1AeJkpMFtMeta?.path ?? "",
    meta: indexx1AeJkpMFtMeta || {},
    alias: indexx1AeJkpMFtMeta?.alias || [],
    redirect: indexx1AeJkpMFtMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93q8OCAXPX7oMeta?.name ?? "customer-orders-rate-orderNumber___ru",
    path: _91orderNumber_93q8OCAXPX7oMeta?.path ?? "rate/:orderNumber()",
    meta: _91orderNumber_93q8OCAXPX7oMeta || {},
    alias: _91orderNumber_93q8OCAXPX7oMeta?.alias || [],
    redirect: _91orderNumber_93q8OCAXPX7oMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders/rate/[orderNumber].vue").then(m => m.default || m)
  }
],
    name: ordersBKz5sOuGmdMeta?.name ?? undefined,
    meta: ordersBKz5sOuGmdMeta || {},
    alias: ordersBKz5sOuGmdMeta?.alias || [],
    redirect: ordersBKz5sOuGmdMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlisteav88h2NmxMeta?.name ?? "customer-wishlist___ru",
    path: wishlisteav88h2NmxMeta?.path ?? "wishlist",
    meta: wishlisteav88h2NmxMeta || {},
    alias: wishlisteav88h2NmxMeta?.alias || [],
    redirect: wishlisteav88h2NmxMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer/wishlist.vue").then(m => m.default || m)
  }
],
    meta: customerwrZT4s7QMEMeta || {},
    alias: customerwrZT4s7QMEMeta?.alias || [],
    redirect: customerwrZT4s7QMEMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/customer.vue").then(m => m.default || m)
  },
  {
    name: indexodtvIbq6gWMeta?.name ?? "index",
    path: indexodtvIbq6gWMeta?.path ?? "/",
    meta: indexodtvIbq6gWMeta || {},
    alias: indexodtvIbq6gWMeta?.alias || [],
    redirect: indexodtvIbq6gWMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexodtvIbq6gWMeta?.name ?? "index___pl",
    path: indexodtvIbq6gWMeta?.path ?? "/pl",
    meta: indexodtvIbq6gWMeta || {},
    alias: indexodtvIbq6gWMeta?.alias || [],
    redirect: indexodtvIbq6gWMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexodtvIbq6gWMeta?.name ?? "index___en",
    path: indexodtvIbq6gWMeta?.path ?? "/en",
    meta: indexodtvIbq6gWMeta || {},
    alias: indexodtvIbq6gWMeta?.alias || [],
    redirect: indexodtvIbq6gWMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexodtvIbq6gWMeta?.name ?? "index___ru",
    path: indexodtvIbq6gWMeta?.path ?? "/ru",
    meta: indexodtvIbq6gWMeta || {},
    alias: indexodtvIbq6gWMeta?.alias || [],
    redirect: indexodtvIbq6gWMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginvTmctQqsFBMeta?.name ?? "login",
    path: loginvTmctQqsFBMeta?.path ?? "/login",
    meta: loginvTmctQqsFBMeta || {},
    alias: loginvTmctQqsFBMeta?.alias || [],
    redirect: loginvTmctQqsFBMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginvTmctQqsFBMeta?.name ?? "login___pl",
    path: loginvTmctQqsFBMeta?.path ?? "/pl/login",
    meta: loginvTmctQqsFBMeta || {},
    alias: loginvTmctQqsFBMeta?.alias || [],
    redirect: loginvTmctQqsFBMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginvTmctQqsFBMeta?.name ?? "login___en",
    path: loginvTmctQqsFBMeta?.path ?? "/en/login",
    meta: loginvTmctQqsFBMeta || {},
    alias: loginvTmctQqsFBMeta?.alias || [],
    redirect: loginvTmctQqsFBMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginvTmctQqsFBMeta?.name ?? "login___ru",
    path: loginvTmctQqsFBMeta?.path ?? "/ru/login",
    meta: loginvTmctQqsFBMeta || {},
    alias: loginvTmctQqsFBMeta?.alias || [],
    redirect: loginvTmctQqsFBMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/login.vue").then(m => m.default || m)
  },
  {
    path: newsletter_45wypisS1I7Yq3croMeta?.path ?? "/newsletter-wypis",
    children: [
  {
    name: indexw6sBeUNupVMeta?.name ?? "newsletter-wypis",
    path: indexw6sBeUNupVMeta?.path ?? "",
    meta: indexw6sBeUNupVMeta || {},
    alias: indexw6sBeUNupVMeta?.alias || [],
    redirect: indexw6sBeUNupVMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter-wypis/index.vue").then(m => m.default || m)
  }
],
    name: newsletter_45wypisS1I7Yq3croMeta?.name ?? undefined,
    meta: newsletter_45wypisS1I7Yq3croMeta || {},
    alias: newsletter_45wypisS1I7Yq3croMeta?.alias || [],
    redirect: newsletter_45wypisS1I7Yq3croMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter-wypis.vue").then(m => m.default || m)
  },
  {
    path: newsletter_45wypisS1I7Yq3croMeta?.path ?? "/pl/newsletter-wypis",
    children: [
  {
    name: indexw6sBeUNupVMeta?.name ?? "newsletter-wypis___pl",
    path: indexw6sBeUNupVMeta?.path ?? "",
    meta: indexw6sBeUNupVMeta || {},
    alias: indexw6sBeUNupVMeta?.alias || [],
    redirect: indexw6sBeUNupVMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter-wypis/index.vue").then(m => m.default || m)
  }
],
    name: newsletter_45wypisS1I7Yq3croMeta?.name ?? undefined,
    meta: newsletter_45wypisS1I7Yq3croMeta || {},
    alias: newsletter_45wypisS1I7Yq3croMeta?.alias || [],
    redirect: newsletter_45wypisS1I7Yq3croMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter-wypis.vue").then(m => m.default || m)
  },
  {
    path: newsletter_45wypisS1I7Yq3croMeta?.path ?? "/en/newsletter-wypis",
    children: [
  {
    name: indexw6sBeUNupVMeta?.name ?? "newsletter-wypis___en",
    path: indexw6sBeUNupVMeta?.path ?? "",
    meta: indexw6sBeUNupVMeta || {},
    alias: indexw6sBeUNupVMeta?.alias || [],
    redirect: indexw6sBeUNupVMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter-wypis/index.vue").then(m => m.default || m)
  }
],
    name: newsletter_45wypisS1I7Yq3croMeta?.name ?? undefined,
    meta: newsletter_45wypisS1I7Yq3croMeta || {},
    alias: newsletter_45wypisS1I7Yq3croMeta?.alias || [],
    redirect: newsletter_45wypisS1I7Yq3croMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter-wypis.vue").then(m => m.default || m)
  },
  {
    path: newsletter_45wypisS1I7Yq3croMeta?.path ?? "/ru/newsletter-wypis",
    children: [
  {
    name: indexw6sBeUNupVMeta?.name ?? "newsletter-wypis___ru",
    path: indexw6sBeUNupVMeta?.path ?? "",
    meta: indexw6sBeUNupVMeta || {},
    alias: indexw6sBeUNupVMeta?.alias || [],
    redirect: indexw6sBeUNupVMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter-wypis/index.vue").then(m => m.default || m)
  }
],
    name: newsletter_45wypisS1I7Yq3croMeta?.name ?? undefined,
    meta: newsletter_45wypisS1I7Yq3croMeta || {},
    alias: newsletter_45wypisS1I7Yq3croMeta?.alias || [],
    redirect: newsletter_45wypisS1I7Yq3croMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter-wypis.vue").then(m => m.default || m)
  },
  {
    path: newsletterQt8Ut9vhktMeta?.path ?? "/newsletter",
    children: [
  {
    name: confirmZYYZt641yfMeta?.name ?? "newsletter-confirm",
    path: confirmZYYZt641yfMeta?.path ?? "confirm",
    meta: confirmZYYZt641yfMeta || {},
    alias: confirmZYYZt641yfMeta?.alias || [],
    redirect: confirmZYYZt641yfMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter/confirm.vue").then(m => m.default || m)
  },
  {
    name: indexfqhv1H4qJSMeta?.name ?? "newsletter",
    path: indexfqhv1H4qJSMeta?.path ?? "",
    meta: indexfqhv1H4qJSMeta || {},
    alias: indexfqhv1H4qJSMeta?.alias || [],
    redirect: indexfqhv1H4qJSMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter/index.vue").then(m => m.default || m)
  },
  {
    name: remove5JYBSBVJ81Meta?.name ?? "newsletter-remove",
    path: remove5JYBSBVJ81Meta?.path ?? "remove",
    meta: remove5JYBSBVJ81Meta || {},
    alias: remove5JYBSBVJ81Meta?.alias || [],
    redirect: remove5JYBSBVJ81Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter/remove.vue").then(m => m.default || m)
  }
],
    name: newsletterQt8Ut9vhktMeta?.name ?? undefined,
    meta: newsletterQt8Ut9vhktMeta || {},
    alias: newsletterQt8Ut9vhktMeta?.alias || [],
    redirect: newsletterQt8Ut9vhktMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter.vue").then(m => m.default || m)
  },
  {
    path: newsletterQt8Ut9vhktMeta?.path ?? "/pl/newsletter",
    children: [
  {
    name: confirmZYYZt641yfMeta?.name ?? "newsletter-confirm___pl",
    path: confirmZYYZt641yfMeta?.path ?? "confirm",
    meta: confirmZYYZt641yfMeta || {},
    alias: confirmZYYZt641yfMeta?.alias || [],
    redirect: confirmZYYZt641yfMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter/confirm.vue").then(m => m.default || m)
  },
  {
    name: indexfqhv1H4qJSMeta?.name ?? "newsletter___pl",
    path: indexfqhv1H4qJSMeta?.path ?? "",
    meta: indexfqhv1H4qJSMeta || {},
    alias: indexfqhv1H4qJSMeta?.alias || [],
    redirect: indexfqhv1H4qJSMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter/index.vue").then(m => m.default || m)
  },
  {
    name: remove5JYBSBVJ81Meta?.name ?? "newsletter-remove___pl",
    path: remove5JYBSBVJ81Meta?.path ?? "remove",
    meta: remove5JYBSBVJ81Meta || {},
    alias: remove5JYBSBVJ81Meta?.alias || [],
    redirect: remove5JYBSBVJ81Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter/remove.vue").then(m => m.default || m)
  }
],
    name: newsletterQt8Ut9vhktMeta?.name ?? undefined,
    meta: newsletterQt8Ut9vhktMeta || {},
    alias: newsletterQt8Ut9vhktMeta?.alias || [],
    redirect: newsletterQt8Ut9vhktMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter.vue").then(m => m.default || m)
  },
  {
    path: newsletterQt8Ut9vhktMeta?.path ?? "/en/newsletter",
    children: [
  {
    name: confirmZYYZt641yfMeta?.name ?? "newsletter-confirm___en",
    path: confirmZYYZt641yfMeta?.path ?? "confirm",
    meta: confirmZYYZt641yfMeta || {},
    alias: confirmZYYZt641yfMeta?.alias || [],
    redirect: confirmZYYZt641yfMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter/confirm.vue").then(m => m.default || m)
  },
  {
    name: indexfqhv1H4qJSMeta?.name ?? "newsletter___en",
    path: indexfqhv1H4qJSMeta?.path ?? "",
    meta: indexfqhv1H4qJSMeta || {},
    alias: indexfqhv1H4qJSMeta?.alias || [],
    redirect: indexfqhv1H4qJSMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter/index.vue").then(m => m.default || m)
  },
  {
    name: remove5JYBSBVJ81Meta?.name ?? "newsletter-remove___en",
    path: remove5JYBSBVJ81Meta?.path ?? "remove",
    meta: remove5JYBSBVJ81Meta || {},
    alias: remove5JYBSBVJ81Meta?.alias || [],
    redirect: remove5JYBSBVJ81Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter/remove.vue").then(m => m.default || m)
  }
],
    name: newsletterQt8Ut9vhktMeta?.name ?? undefined,
    meta: newsletterQt8Ut9vhktMeta || {},
    alias: newsletterQt8Ut9vhktMeta?.alias || [],
    redirect: newsletterQt8Ut9vhktMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter.vue").then(m => m.default || m)
  },
  {
    path: newsletterQt8Ut9vhktMeta?.path ?? "/ru/newsletter",
    children: [
  {
    name: confirmZYYZt641yfMeta?.name ?? "newsletter-confirm___ru",
    path: confirmZYYZt641yfMeta?.path ?? "confirm",
    meta: confirmZYYZt641yfMeta || {},
    alias: confirmZYYZt641yfMeta?.alias || [],
    redirect: confirmZYYZt641yfMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter/confirm.vue").then(m => m.default || m)
  },
  {
    name: indexfqhv1H4qJSMeta?.name ?? "newsletter___ru",
    path: indexfqhv1H4qJSMeta?.path ?? "",
    meta: indexfqhv1H4qJSMeta || {},
    alias: indexfqhv1H4qJSMeta?.alias || [],
    redirect: indexfqhv1H4qJSMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter/index.vue").then(m => m.default || m)
  },
  {
    name: remove5JYBSBVJ81Meta?.name ?? "newsletter-remove___ru",
    path: remove5JYBSBVJ81Meta?.path ?? "remove",
    meta: remove5JYBSBVJ81Meta || {},
    alias: remove5JYBSBVJ81Meta?.alias || [],
    redirect: remove5JYBSBVJ81Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter/remove.vue").then(m => m.default || m)
  }
],
    name: newsletterQt8Ut9vhktMeta?.name ?? undefined,
    meta: newsletterQt8Ut9vhktMeta || {},
    alias: newsletterQt8Ut9vhktMeta?.alias || [],
    redirect: newsletterQt8Ut9vhktMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/newsletter.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93G8QBJF6FuvMeta?.name ?? "p-slug",
    path: _91_46_46_46slug_93G8QBJF6FuvMeta?.path ?? "/p/:slug(.*)*",
    meta: _91_46_46_46slug_93G8QBJF6FuvMeta || {},
    alias: _91_46_46_46slug_93G8QBJF6FuvMeta?.alias || [],
    redirect: _91_46_46_46slug_93G8QBJF6FuvMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-product-page-layer/pages/p/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93G8QBJF6FuvMeta?.name ?? "p-slug___pl",
    path: _91_46_46_46slug_93G8QBJF6FuvMeta?.path ?? "/pl/p/:slug(.*)*",
    meta: _91_46_46_46slug_93G8QBJF6FuvMeta || {},
    alias: _91_46_46_46slug_93G8QBJF6FuvMeta?.alias || [],
    redirect: _91_46_46_46slug_93G8QBJF6FuvMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-product-page-layer/pages/p/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93G8QBJF6FuvMeta?.name ?? "p-slug___en",
    path: _91_46_46_46slug_93G8QBJF6FuvMeta?.path ?? "/en/p/:slug(.*)*",
    meta: _91_46_46_46slug_93G8QBJF6FuvMeta || {},
    alias: _91_46_46_46slug_93G8QBJF6FuvMeta?.alias || [],
    redirect: _91_46_46_46slug_93G8QBJF6FuvMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-product-page-layer/pages/p/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93G8QBJF6FuvMeta?.name ?? "p-slug___ru",
    path: _91_46_46_46slug_93G8QBJF6FuvMeta?.path ?? "/ru/p/:slug(.*)*",
    meta: _91_46_46_46slug_93G8QBJF6FuvMeta || {},
    alias: _91_46_46_46slug_93G8QBJF6FuvMeta?.alias || [],
    redirect: _91_46_46_46slug_93G8QBJF6FuvMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-product-page-layer/pages/p/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91id_93j5ViPVwKblMeta?.name ?? "p-id",
    path: _91id_93j5ViPVwKblMeta?.path ?? "/p/:id()",
    meta: _91id_93j5ViPVwKblMeta || {},
    alias: _91id_93j5ViPVwKblMeta?.alias || [],
    redirect: _91id_93j5ViPVwKblMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/p/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93j5ViPVwKblMeta?.name ?? "p-id___pl",
    path: _91id_93j5ViPVwKblMeta?.path ?? "/pl/p/:id()",
    meta: _91id_93j5ViPVwKblMeta || {},
    alias: _91id_93j5ViPVwKblMeta?.alias || [],
    redirect: _91id_93j5ViPVwKblMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/p/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93j5ViPVwKblMeta?.name ?? "p-id___en",
    path: _91id_93j5ViPVwKblMeta?.path ?? "/en/p/:id()",
    meta: _91id_93j5ViPVwKblMeta || {},
    alias: _91id_93j5ViPVwKblMeta?.alias || [],
    redirect: _91id_93j5ViPVwKblMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/p/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93j5ViPVwKblMeta?.name ?? "p-id___ru",
    path: _91id_93j5ViPVwKblMeta?.path ?? "/ru/p/:id()",
    meta: _91id_93j5ViPVwKblMeta || {},
    alias: _91id_93j5ViPVwKblMeta?.alias || [],
    redirect: _91id_93j5ViPVwKblMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/p/[id].vue").then(m => m.default || m)
  },
  {
    name: registerxurUmqSuADMeta?.name ?? "register",
    path: registerxurUmqSuADMeta?.path ?? "/register",
    meta: registerxurUmqSuADMeta || {},
    alias: registerxurUmqSuADMeta?.alias || [],
    redirect: registerxurUmqSuADMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerxurUmqSuADMeta?.name ?? "register___pl",
    path: registerxurUmqSuADMeta?.path ?? "/pl/register",
    meta: registerxurUmqSuADMeta || {},
    alias: registerxurUmqSuADMeta?.alias || [],
    redirect: registerxurUmqSuADMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerxurUmqSuADMeta?.name ?? "register___en",
    path: registerxurUmqSuADMeta?.path ?? "/en/register",
    meta: registerxurUmqSuADMeta || {},
    alias: registerxurUmqSuADMeta?.alias || [],
    redirect: registerxurUmqSuADMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerxurUmqSuADMeta?.name ?? "register___ru",
    path: registerxurUmqSuADMeta?.path ?? "/ru/register",
    meta: registerxurUmqSuADMeta || {},
    alias: registerxurUmqSuADMeta?.alias || [],
    redirect: registerxurUmqSuADMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-account-layer/pages/register.vue").then(m => m.default || m)
  },
  {
    name: srPzQGllGYDMeta?.name ?? "s",
    path: srPzQGllGYDMeta?.path ?? "/s",
    meta: srPzQGllGYDMeta || {},
    alias: srPzQGllGYDMeta?.alias || [],
    redirect: srPzQGllGYDMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/s.vue").then(m => m.default || m)
  },
  {
    name: srPzQGllGYDMeta?.name ?? "s___pl",
    path: srPzQGllGYDMeta?.path ?? "/pl/s",
    meta: srPzQGllGYDMeta || {},
    alias: srPzQGllGYDMeta?.alias || [],
    redirect: srPzQGllGYDMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/s.vue").then(m => m.default || m)
  },
  {
    name: srPzQGllGYDMeta?.name ?? "s___en",
    path: srPzQGllGYDMeta?.path ?? "/en/s",
    meta: srPzQGllGYDMeta || {},
    alias: srPzQGllGYDMeta?.alias || [],
    redirect: srPzQGllGYDMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/s.vue").then(m => m.default || m)
  },
  {
    name: srPzQGllGYDMeta?.name ?? "s___ru",
    path: srPzQGllGYDMeta?.path ?? "/ru/s",
    meta: srPzQGllGYDMeta || {},
    alias: srPzQGllGYDMeta?.alias || [],
    redirect: srPzQGllGYDMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/pages/s.vue").then(m => m.default || m)
  },
  {
    name: storeLocatorL6LmSux5yWMeta?.name ?? "storeLocator",
    path: storeLocatorL6LmSux5yWMeta?.path ?? "/storeLocator",
    meta: storeLocatorL6LmSux5yWMeta || {},
    alias: storeLocatorL6LmSux5yWMeta?.alias || [],
    redirect: storeLocatorL6LmSux5yWMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-store-locator-layer/pages/storeLocator.vue").then(m => m.default || m)
  },
  {
    name: storeLocatorL6LmSux5yWMeta?.name ?? "storeLocator___pl",
    path: storeLocatorL6LmSux5yWMeta?.path ?? "/pl/adresy-sklepow",
    meta: storeLocatorL6LmSux5yWMeta || {},
    alias: storeLocatorL6LmSux5yWMeta?.alias || [],
    redirect: storeLocatorL6LmSux5yWMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-store-locator-layer/pages/storeLocator.vue").then(m => m.default || m)
  },
  {
    name: storeLocatorL6LmSux5yWMeta?.name ?? "storeLocator___en",
    path: storeLocatorL6LmSux5yWMeta?.path ?? "/en/adresy-sklepow",
    meta: storeLocatorL6LmSux5yWMeta || {},
    alias: storeLocatorL6LmSux5yWMeta?.alias || [],
    redirect: storeLocatorL6LmSux5yWMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-store-locator-layer/pages/storeLocator.vue").then(m => m.default || m)
  },
  {
    name: storeLocatorL6LmSux5yWMeta?.name ?? "storeLocator___ru",
    path: storeLocatorL6LmSux5yWMeta?.path ?? "/ru/adresy-sklepow",
    meta: storeLocatorL6LmSux5yWMeta || {},
    alias: storeLocatorL6LmSux5yWMeta?.alias || [],
    redirect: storeLocatorL6LmSux5yWMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-store-locator-layer/pages/storeLocator.vue").then(m => m.default || m)
  }
]